import { Box, HStack } from "native-base";
import React, { useRef, useEffect } from "react";
import { Svg } from "react-native-svg";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { downloadIconSVG } from "../../utils/svg";

const ImageViewerJs = ({
  src,
  destroy = true,
  text = "",
  width = undefined,
}) => {
  const imageRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    viewerRef.current = new Viewer(imageRef.current, {
      navbar: false,
      toolbar: false,
      shown: function () {
        viewerRef.current.view();
      },
    });
    if (destroy) return () => viewerRef.current.destroy();
  }, []);

  const handleButtonClick = () => {
    viewerRef.current.show();
  };

  return (
    <div style={{ width: width }}>
      <img ref={imageRef} src={src} alt="Preview" style={{ display: "none" }} />
      <HStack
        onClick={handleButtonClick}
        width={width}
        alignItems={width && "center"}
      >
        {text && (
          <Box
            flex={1}
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            mr={2}
            mt={-1}
          >
            {text}
          </Box>
        )}
        {/* <i className="fa fa-download pointer"></i>{" "} */}
        <Svg width="50" height="40" viewBox={"12 0 1 36"}>
          {downloadIconSVG}
        </Svg>
      </HStack>
    </div>
  );
};

export default ImageViewerJs;
